import CloseButton from "./closeButton";

/**
 * モーダル用のヘッダ
 * @param props
 * @returns
 */
export default function ModalHeader({ title, onClose }) {
  return (
    <div className="header">
      <h3>{title}</h3>
      <CloseButton onClose={onClose} />
    </div>
  );
}
